import { useContext, useEffect } from "react";

import { Grid } from "@material-ui/core";

import {
  VendedoresContext,
  VendedoresContextProvider,
} from "./contexts/VendedoresContext";

import Loading from "../../../components/basics/Loading";
import HeaderModule from "../../../components/header/HeaderModule";
import Btn from "../../../components/buttons/Btn";
import AccordionVendedorGeral from "./children/AccordionVendedorGeral";
import AccordionVendedorInfosBancarias from "./children/AccordionVendedorInfosBancarias";
import { findEstado } from "../../../repository/ERP/prouser/EstadoService";
import { findMunicipio } from "../../../repository/ERP/prouser/MunicipioService";
import { findRegiaoComercial } from "../../../repository/ERP/prouser/RegiaoComercialService";
import { findPais } from "../../../repository/ERP/prouser/PaisService";
import { findEmpresa } from "../../../repository/ERP/prouser/EmpresaService";
import { findBancos } from "../../../repositories/qerpapi/v3/BancosRepository";
import { PainelContainer } from "./styles/Vendedor";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import useVendedorController from "./controllers/VendedorController";
import { findVendedores } from "../../../repositories/qerpapi/erp/vendas/v1/VendedoresRepository";
import { findTabelaComissao } from "../../../repository/ERP/vendas/TabelaComissaoService";
import { validarCNPJ, validarCPF } from "../../../utils/validations";
import MaskService from "../../../utils/mask/maskService";
import { GlobalVariables } from "../../../GlobalVariables";

const Page = ({ location }) => {
  const { handleSubmit, handleBackSubmit, handleCancelSubmit } =
    useVendedorController();

  const { queryParams } = useContext(QueryParamsContext);

  const {
    loading,
    setLoading,
    setLoadingInputs,
    listUf,
    setListUf,
    listCounty,
    sellerType,
    listCommercialRegion,
    listCompanies,
    setListCounty,
    setListNation,
    setListCommercialRegion,
    setListCompanies,
    setListBank,
    setGeralCpfCnpj,
    setGeralRazao,
    setGeralFantasia,
    setGeralCEP,
    setGeralEndereco,
    setGeralNumero,
    setGeralComplemento,
    setGeralBairro,
    setGeralEstado,
    setGeralMunicipio,
    setGeralPais,
    setGeralTel1,
    setGeralTel2,
    setGeralTel3,
    setGeralEmail,
    setGeralComissaoVenda,
    setGeralTipoVendedor,
    setGeralEmpresa,
    setGeralCarteiraPropria,
    setGeralAtivo,
    setGeralVendedorId,
    setGeralRegiaoComercial,
    setBank,
    dataSellerEdit,
    setDataSellerEdit,
    listComissions,
    setListComissions,
    setGeralComission,
    setValidCpfCnpj,
  } = useContext(VendedoresContext);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listUf: true,
        }));
        const resultUf = await findEstado(queryParams.empresa_cnpj);
        if (resultUf.success) setListUf(resultUf.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listUf: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListUf, setLoadingInputs]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listCounty: true,
        }));

        const resultCounty = await findMunicipio(
          queryParams.empresa_cnpj,
          null,
          "municipio"
        );
        if (resultCounty.success) setListCounty(resultCounty.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listCounty: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListCounty, setLoadingInputs]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listNation: true,
        }));
        const resultNation = await findPais(queryParams.empresa_cnpj);
        if (resultNation.success) {
          setListNation(resultNation.data);
          setGeralPais(
            resultNation.data.find((nation) => nation.codigo === "1058") || null
          );
        }
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listNation: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setGeralPais, setListNation, setLoadingInputs]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listRegion: true,
        }));
        const resultRegion = await findRegiaoComercial(
          queryParams.empresa_cnpj
        );

        if (resultRegion.success) setListCommercialRegion(resultRegion.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listRegion: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListCommercialRegion, setLoadingInputs]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listCompanies: true,
        }));
        const resultCompanies = await findEmpresa(queryParams.empresa_cnpj);

        if (resultCompanies.success)
          if (resultCompanies.success) setListCompanies(resultCompanies.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listCompanies: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListCompanies, setLoadingInputs]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listBank: true,
        }));

        const resultBank = await findBancos();

        if (resultBank.success) setListBank(resultBank.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listBank: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListBank, setLoadingInputs]);

  useEffect(() => {
    if (!location.state?.item?.id) return;
    (async () => {
      try {
        setLoading(true);
        const dataVendedor = await findVendedores({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: location.state.item.id,
          include: "contasbancarias",
        });

        const { data } = dataVendedor;
        setDataSellerEdit(data);

        const cpfOrCnpj =
          (data?.cpfcnpj || "").replace(/[^0-9]+/g, "").length === 11
            ? "cpf"
            : "cnpj";

        if (cpfOrCnpj === "cpf") {
          setValidCpfCnpj(validarCPF(data?.cpfcnpj || ""));
        } else {
          setValidCpfCnpj(validarCNPJ(data?.cpfcnpj || ""));
        }

        setGeralVendedorId(data.id || null);
        setGeralCpfCnpj(MaskService.toMask(cpfOrCnpj, data?.cpfcnpj || ""));
        setGeralRazao(data.nomevendedor || "");
        setGeralFantasia(data.apelido || "");
        setGeralCEP(data.cep || "");
        setGeralEndereco(data.endereco || "");
        setGeralNumero(data.numero || "");
        setGeralComplemento(data.complemento || "");
        setGeralBairro(data.bairro || "");
        setGeralTel1(data.telefone || "");
        setGeralTel2(data.telefone2 || "");
        setGeralTel3(data.telefone3 || "");
        setGeralEmail(data.email || "");
        setGeralComissaoVenda(data.comissao || "");
        setGeralCarteiraPropria(data.possuicarteira === "S");
        setGeralAtivo(data.ativo === "S");
        setBank(data.contasbancarias || "");
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [
    location,
    queryParams.empresa_cnpj,
    setBank,
    setDataSellerEdit,
    setGeralAtivo,
    setGeralBairro,
    setGeralCEP,
    setGeralCarteiraPropria,
    setGeralComissaoVenda,
    setGeralComplemento,
    setGeralCpfCnpj,
    setGeralEmail,
    setGeralEndereco,
    setGeralFantasia,
    setGeralNumero,
    setGeralRazao,
    setGeralTel1,
    setGeralTel2,
    setGeralTel3,
    setGeralVendedorId,
    setLoading,
    setValidCpfCnpj,
  ]);

  useEffect(() => {
    if (!dataSellerEdit.id_estado) return;
    setGeralEstado(
      listUf.find(
        (estado) => estado.id.toString() === dataSellerEdit.id_estado
      ) || null
    );
  }, [dataSellerEdit.id_estado, listUf, setGeralEstado]);

  useEffect(() => {
    if (!dataSellerEdit.cidade) return;
    setGeralMunicipio(
      listCounty.find((cidade) => cidade.codigo === dataSellerEdit.cidade) ||
        null
    );
  }, [dataSellerEdit.cidade, listCounty, setGeralMunicipio]);

  useEffect(() => {
    if (!dataSellerEdit.tipo || !sellerType.length) return;
    setGeralTipoVendedor(
      sellerType.find((tipo) => tipo.value === dataSellerEdit.tipo) || null
    );
  }, [dataSellerEdit.tipo, sellerType, setGeralTipoVendedor]);

  useEffect(() => {
    if (!dataSellerEdit.regiaocomercial || !listCommercialRegion.length) return;
    setGeralRegiaoComercial(
      listCommercialRegion.find(
        (regiao) => regiao.id === dataSellerEdit.regiaocomercial
      ) || null
    );
  }, [
    dataSellerEdit.regiaocomercial,
    listCommercialRegion,
    setGeralRegiaoComercial,
  ]);

  useEffect(() => {
    if (!dataSellerEdit.idempresa || !listCompanies.length) return;
    setGeralEmpresa(
      listCompanies.find(
        (empresa) => empresa.id === dataSellerEdit.idempresa
      ) || null
    );
  }, [dataSellerEdit.idempresa, listCompanies, setGeralEmpresa]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listComissions: true,
        }));
        const resultUf = await findTabelaComissao(queryParams.empresa_cnpj);
        if (resultUf.success) setListComissions(resultUf.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listComissions: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListComissions, setLoadingInputs]);

  useEffect(() => {
    if (!dataSellerEdit.idtabelacomissao || !listComissions.length) return;
    setGeralComission(
      listComissions.find(
        (tabelacomissao) =>
          tabelacomissao.id === dataSellerEdit.idtabelacomissao
      ) || null
    );
  }, [dataSellerEdit.idtabelacomissao, listComissions, setGeralComission]);

  return (
    <>
      <Loading open={loading} />
      <HeaderModule
        title="CADASTRO DE VENDEDORES"
        textcolor="black"
        videoId={GlobalVariables.screenVideosIds.cadastroVendedores}
      />

      <PainelContainer maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <AccordionVendedorGeral />
          </Grid>
          <Grid item xs={12}>
            <AccordionVendedorInfosBancarias />
          </Grid>
        </Grid>

        <Grid
          item
          container
          justifyContent="flex-end"
          style={{ marginTop: 20, marginBottom: 20 }}
          spacing={1}
        >
          <Grid item>
            <Btn label="Voltar" bgcolor="tertiary" onClick={handleBackSubmit} />
          </Grid>
          <Grid item>
            <Btn
              label="Cancelar"
              bgcolor="tertiary"
              onClick={handleCancelSubmit}
            />
          </Grid>
          <Grid item>
            <Btn label="Salvar" onClick={() => handleSubmit({ location })} />
          </Grid>
        </Grid>
      </PainelContainer>
    </>
  );
};

const VendedoresCadastro = ({ location }) => (
  <VendedoresContextProvider>
    <Page location={location} />
  </VendedoresContextProvider>
);
export { VendedoresCadastro };
